import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { ImageAspectRatio, ImageOrientation } from '../../../Blocks/BlockImageList/ImageSettings';

interface FixedAspectOptionsProps {
  orientation: ImageOrientation;
  aspectRatio: string;
  handleChangeOrientation: (orientation: ImageOrientation) => void;
  handleChangeAspectRatio: (aspect: ImageAspectRatio) => void;
}

const FixedAspectOptions = ({
  orientation,
  aspectRatio,
  handleChangeOrientation,
  handleChangeAspectRatio,
}: FixedAspectOptionsProps) => (
  <>
    <Grid item sx={{ width: '100%', fontSize: '0.75rem' }}>
      <Typography className="col-form-label mb-1 text-sm" sx={{ fontWeight: '700' }}>
        タイプ
      </Typography>
      <FormControl>
        <RadioGroup
          name="radio-buttons-group"
          value={orientation}
          row
          onChange={(event) => handleChangeOrientation((event.target as HTMLInputElement).value as ImageOrientation)}
        >
          <FormControlLabel
            value={ImageOrientation.Square}
            control={<Radio size="small" />}
            label="正方形"
            sx={{ '& .MuiTypography-root': { fontSize: '0.75rem' } }}
          />
          <FormControlLabel
            value={ImageOrientation.Landscape}
            control={<Radio size="small" />}
            label="横向き"
            sx={{ '& .MuiTypography-root': { fontSize: '0.75rem' } }}
          />
          <FormControlLabel
            value={ImageOrientation.Portrait}
            control={<Radio size="small" />}
            label="縦向き"
            sx={{ '& .MuiTypography-root': { fontSize: '0.75rem' } }}
          />
          <FormControlLabel
            value={ImageOrientation.Circle}
            control={<Radio size="small" />}
            label="正円"
            sx={{ '& .MuiTypography-root': { fontSize: '0.75rem' } }}
          />
        </RadioGroup>
      </FormControl>
    </Grid>

    {orientation !== ImageOrientation.Square && orientation !== ImageOrientation.Circle && (
      <>
        <Divider sx={{ width: '100%', my: 1 }} />

        <Grid item sx={{ width: '100%' }}>
          <Typography className="col-form-label mb-1 text-sm" sx={{ fontWeight: '700' }}>
            アスペクト比
          </Typography>
          <FormControl>
            <RadioGroup
              name="aspect-ratio-radio-buttons-group"
              value={aspectRatio}
              row
              onChange={(event) => handleChangeAspectRatio((event.target as HTMLInputElement).value as ImageAspectRatio)}
            >
              <FormControlLabel
                value={ImageAspectRatio.FourByThree}
                control={<Radio size="small" />}
                label={orientation === ImageOrientation.Landscape ? '4:3' : '3:4'}
                sx={{ '& .MuiTypography-root': { fontSize: '0.75rem' } }}
              />
              <FormControlLabel
                value={ImageAspectRatio.SixteenByNine}
                control={<Radio size="small" />}
                label={orientation === ImageOrientation.Landscape ? '16:9' : '9:16'}
                sx={{ '& .MuiTypography-root': { fontSize: '0.75rem' } }}
              />
            </RadioGroup>
          </FormControl>
        </Grid>
      </>
    )}

  </>
);

export default FixedAspectOptions;
